
export enum GlobalSearchDetailCd {
	CLAIM_RESULT = 'ClaimResult',
	DISPUTE_RESULT = 'DisputeResult',
	DMS_RESULT = 'DMSResult',
	INVOICE_RESULT = 'InvoiceResult',
	PN_D_RESULT = 'PnDResult',
	SHIPMENT_RESULT = 'ShipmentResult'}

